'use strict';

var React = require('react');

var SvgBankMajor = function SvgBankMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.54 3.177a1.25 1.25 0 0 0-1.08 0l-5.25 2.51a1.25 1.25 0 0 0-.71 1.128v1.185c0 .69.56 1.25 1.25 1.25v2.75h-.25a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-.25v-2.75c.69 0 1.25-.56 1.25-1.25v-1.185c0-.481-.276-.92-.71-1.128l-5.25-2.51Zm3.21 8.823v-2.75h-1.5v2.75h1.5Zm-3 0v-2.75h-1.5v2.75h1.5Zm-3 0v-2.75h-1.5v2.75h1.5Zm-2.75-5.027 5-2.392 5 2.392v.777h-10v-.777Zm0 7.527v-1h10v1h-10Z"
  }));
};
SvgBankMajor.displayName = "BankMajor";

exports.SvgBankMajor = SvgBankMajor;
